import React, { useEffect, useRef, useState } from 'react';
import { animateScroll } from 'react-scroll';
import cx from 'classnames';
import { throttle } from 'lodash';

import {
  SCROLL_NAVIGATOR_BOTTOM_THRESHOLD,
  SCROLL_NAVIGATOR_ACTIVATION_OFFSET,
} from '../../../../constants/service/app/productConstantsV2';
import './ScrollNavigator.scss';

const ScrollNavigator = ({ list, marginTop = 0 }) => {
  const contentContainerEl = useRef(null);
  const [currentActive, setCurrentActive] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      // 엣지 케이스: ref가 null이거나 children이 없는 경우 조기 반환
      if (!contentContainerEl.current) return;

      const contents = contentContainerEl.current.children;
      if (contents.length === 0) return;

      const minScrollY = contents[0].offsetTop + marginTop;

      // 페이지 하단 근처에 도달했는지 체크 (마지막 섹션 활성화)
      const scrollBottom = window.scrollY + window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      if (scrollBottom >= documentHeight - SCROLL_NAVIGATOR_BOTTOM_THRESHOLD) {
        setCurrentActive(contents.length - 1);
        return;
      }

      if (window.scrollY <= minScrollY) {
        setCurrentActive(0);
        return;
      }

      // 역순으로 순회하여 현재 스크롤 위치에서 가장 가까운 섹션 찾기
      for (let i = contents.length - 1; i >= 0; i--) {
        if (window.scrollY >= contents[i].offsetTop + marginTop - SCROLL_NAVIGATOR_ACTIVATION_OFFSET) {
          setCurrentActive(i);
          return;
        }
      }
    };

    // 스크롤 이벤트 쓰로틀링: 100ms 간격으로 실행하여 성능 최적화
    const throttledScroll = throttle(onScroll, 100);

    window.addEventListener('scroll', throttledScroll);
    onScroll(); // 초기 실행

    return () => {
      window.removeEventListener('scroll', throttledScroll);
      throttledScroll.cancel(); // cleanup 시 대기 중인 호출 취소
    };
  }, [marginTop]);

  const onClickTab = (index) => {
    const target = contentContainerEl.current.children[index];
    // 높이가 소수점일 경우를 대비하기 위해 +1 추가 계산
    animateScroll.scrollTo(target.offsetTop + marginTop + 1, {
      duration: 0,
    });
  };

  return (
    <div className="navs-wrapper">
      <div className="navs-bar">
        <ul className="navs-container">
          {list.map(({ title }, index) => {
            if (title === '') return null;
            return (
              <li key={title} className={cx('nav', { active: index === currentActive })}>
                <button type="button" className="nav-title" onClick={() => onClickTab(index)}>
                  {title}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
      <div className="navs-content" ref={contentContainerEl}>
        {list.map(({ content }, index) => (
          <div key={index}>{content}</div>
        ))}
      </div>
    </div>
  );
};

export default ScrollNavigator;
